//region :: Imports ::
import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import PrimeReact from 'primereact/api';
import App from './App';
import './App.scss';
import ListWorkersPage from './Workers/ListWorkersPage';
import CreateWorkerPage from './Workers/CreateWorkerPage';
import EditWorkerPage from './Workers/EditWorkerPage';
import LogoutPage from './Toolkit/Pages/LogoutPage';
import AITelemetryProvider from './Toolkit/Components/Logging/AITelemetryProvider';
import Environment from './Toolkit/Environment';
import AddWorkerToNhsPage from './Workers/Pages/AddWorkerToNhsPage';
import AccessDeniedPage from './Toolkit/Pages/AccessDeniedPage';
import MAppContainer from './Toolkit/Components/Shell/AppContainer';
import Authorize from "./Toolkit/Components/Auth/Authorize";
import {Roles} from "./Roles";

//endregion

//  PrimeReact
PrimeReact.ripple = true;
PrimeReact.cssTransition = true;

//  Routes
let routes =
    <Routes>
        <Route path="/" element={<MAppContainer/>}>
            <Route path="" element={<App/>}>
                <Route index element={<ListWorkersPage/>}/>
                <Route path="workers" element={<ListWorkersPage/>}/>
                <Route path="workers/create" element={
                    <Authorize roles={[Roles.fullAccess]}>
                        <CreateWorkerPage/>
                    </Authorize>
                }/>
                <Route path="workers/:workerId" element={
                    <Authorize roles={[Roles.fullAccess, Roles.manager]}>
                        <EditWorkerPage/>
                    </Authorize>
                }/>
                <Route path="workers/:workerId/nhs/add" element={<AddWorkerToNhsPage/>}/>
            </Route>
            <Route path="access-denied" element={<AccessDeniedPage/>}/>
            <Route path="logout" element={<LogoutPage/>}/>
        </Route>
    </Routes>;

if(!Environment.isLocal && !Environment.isDevelopment) {
    routes = (
        <AITelemetryProvider connectionString={process.env.REACT_APP_APPINSIGHTS_CONNECTIONSTRING!}>
            {routes}
        </AITelemetryProvider>
    );
}

//  React 18 Render
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            {routes}
        </BrowserRouter>
    </React.StrictMode>
);

//  If you want to start measuring performance in your app, pass a function
//  to log results (for example: reportWebVitals(console.log))
//  or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
